export const roundNum = (amount: number, decimalPlaces: number = 2): string => {
  const options: Intl.NumberFormatOptions =
    decimalPlaces > 0
      ? {
          minimumFractionDigits: decimalPlaces,
          maximumFractionDigits: decimalPlaces,
          roundingMode: "halfExpand",
        }
      : {
          maximumFractionDigits: 0,
          roundingMode: "halfExpand",
        };
  return new Intl.NumberFormat("en-US", options).format(amount);
};

export const calculateDiscount = (
  price1: number,
  price2: number,
  decimals: number = 0
): string => {
  if (price1 > price2) {
    const discount = price1 - price2;
    const discountPercentage = (discount / price1) * 100;
    return discountPercentage.toFixed(decimals);
  } else if (price2 > price1) {
    const discount = price2 - price1;
    const discountPercentage = (discount / price2) * 100;
    return discountPercentage.toFixed(decimals);
  } else {
    return "0";
  }
};

export const isOverLimit = (num: string | number) => {
  return Number(num) > 99999999999.99;
};

export function getGFALFeeFromTotalPurchasePrice(price: number): number {
  const GFALExStore = useGFALExStore();
  const { marketplaceFeesPercent, minimumPrice } = useRuntimeConfig().public;
  const minimumPriceGFAL = Number(minimumPrice) / GFALExStore.GFALExRate;
  const marketplaceFee = price * (Number(marketplaceFeesPercent) / 100);
  if (marketplaceFee > minimumPriceGFAL) {
    return marketplaceFee;
  } else {
    return minimumPriceGFAL;
  }
}
